export type Speaker = {
    image: string;
    name: string,
    description_pl: string,
    description_en: string,
}

export const speakers: Speaker[] = [
    {
        image: "/static/About/Speakers/TOM_AVERMAETE.png",
        name: "Tom Avermaete",
        description_pl: "Profesor zwyczajny historii i teorii urbanistyki oraz prodziekan Wydziału Architektury (D-ARCH) na ETH w Zurychu, Szwajcaria",
        description_en: "Full Professor for the History and Theory of Urban Design and Vice-Dean of the Department of Architecture (D-ARCH) at ETH Zürich, Switzerland",
    },
    {
        image: "/static/About/Speakers/ROBERTO_CAVALLO.png",
        name: "Roberto Cavallo",
        description_pl: "Profesor nadzwyczajny w Katedrze Architektury na Wydziale Architektury i Środowiska Zbudowanego, Uniwersytet Techniczny w Delft",
        description_en: "Associate professor in the Department of Architecture at the Faculty of Architecture & the Built Environment, Delft University of Technology",
    },
    {
        image: "/static/About/Speakers/KEES_CHRISTIAANSE.png",
        name: "Kees Christiaanse",
        description_pl: "Profesor emerytowany, dr hab. Instytut Projektowania i Architektury, Wydział Architektury ETH Zürich",
        description_en: "Professor Emeritus, Ph.D. Institute of Design and Architecture Department of Architecture ETH Zürich",
    },
    {
        image: "/static/About/Speakers/MICHAEL_J_CROSBIE.png",
        name: "Michael J. Crosbie",
        description_pl: "Profesor architektury na Uniwersytecie Hartford",
        description_en: "Professor of Architecture at the University of Hartford",
    },
    {
        image: "/static/About/Speakers/JUANJO_GALAN.png",
        name: "Juanjo Galan",
        description_pl: "Profesor nadzwyczajny w Katedrze Urbanistyki Uniwersytetu Politechnicznego w Walencji (Hiszpania)",
        description_en: "Associate Professor in the Department of Urban Planning of the Universitat Politècnica de València (Spain)",
    },
    {
        image: "/static/About/Speakers/MAŁGORZATA MADER.png",
        name: "Małgorzata Mader",
        description_pl: "Adiunkt i architekt związana z Politechniką Łódzką",
        description_en: "Assistant professor and architect based at Lodz University of Technology",
    },
    {
        image: "/static/About/Speakers/APOLONIA_BEGONA_SERRANO_LANZAROTE.png",
        name: "Apolonia Begoña Serrano Lanzarote",
        description_pl: "Doktor nauk w zakresie architektury na Politechnice w Walencji oraz Dyrektor Katedry Maderamen",
        description_en: "PhD in Architecture from the Polytechnic University of Valencia and Director of the Maderamen Chair",
    },
    {
        image: "/static/About/Speakers/SPELA_VEROVSEK.png",
        name: "Špela Verovšek",
        description_pl: "Adiunkt i badacz w dziedzinie urbanistyki na Wydziale Architektury Uniwersytetu w Lublanie",
        description_en: "Assistant professor and researcher in the field of urbanism at the Faculty of Architecture, University of Ljubljana",
    },
];
